import React from "react";
import { Star, Eye } from "lucide-react";

export default function Dashboard5() {
  const bestsellersQuantity = [
    { name: "Leica T Mirrorless Digital Camera", qty: 1, amount: "$530.00" },
    { name: "Apple iCam", qty: 1, amount: "$1,300.00" },
    { name: "Levi's 511 Jeans", qty: 1, amount: "$43.50" },
    { name: "Night Visions", qty: 1, amount: "$2.80" },
    { name: "If You Wait (donation)", qty: 1, amount: "$3.00" },
  ];

  const bestsellersAmount = [
    { name: "Vintage Style Engagement Ring", qty: 1, amount: "$2,100.00" },
    { name: "Apple iCam", qty: 1, amount: "$1,300.00" },
    { name: "Leica T Mirrorless Digital Camera", qty: 1, amount: "$530.00" },
    { name: "Flower Girl Bracelet", qty: 1, amount: "$360.00" },
    { name: "First Prize Pies", qty: 1, amount: "$51.00" },
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
      {/* Bestsellers by Quantity */}
      <div className="bg-white rounded-md shadow border overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between border-b px-4 py-2">
          <div className="flex items-center gap-2 text-gray-700 font-semibold">
            <Star size={18} />
            Bestsellers by quantity
          </div>
          <button className="text-gray-400 text-xl font-bold hover:text-gray-600">
            –
          </button>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-left border-collapse">
            <thead>
              <tr className="bg-gray-100 text-gray-700">
                <th className="px-4 py-2 border">Name</th>
                <th className="px-4 py-2 border text-center">Total quantity</th>
                <th className="px-4 py-2 border">Total amount (excl tax)</th>
                <th className="px-4 py-2 border">View</th>
              </tr>
            </thead>
            <tbody>
              {bestsellersQuantity.map((item, i) => (
                <tr key={i} className="border-t hover:bg-gray-50">
                  <td className="px-4 py-2 border">{item.name}</td>
                  <td className="px-4 py-2 border text-center">{item.qty}</td>
                  <td className="px-4 py-2 border">{item.amount}</td>
                  <td className="px-4 py-2 border text-center">
                    <button className="flex items-center gap-1 bg-gray-100 hover:bg-gray-200 text-gray-700 text-xs font-medium px-3 py-1 rounded">
                      <Eye size={14} /> View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer Pagination */}
        <div className="flex justify-between items-center border-t px-4 py-2 text-sm text-gray-600">
          <div className="flex items-center gap-1">
            <button className="border px-3 py-1 rounded-l bg-white hover:bg-gray-100">
              Previous
            </button>
            <button className="bg-blue-600 text-white px-3 py-1">1</button>
            <button className="border px-3 py-1 bg-white hover:bg-gray-100">
              2
            </button>
            <button className="border px-3 py-1 bg-white hover:bg-gray-100">
              3
            </button>
            <button className="border px-3 py-1 rounded-r bg-white hover:bg-gray-100">
              Next
            </button>
          </div>
          <span>1-5 of 12 items</span>
        </div>
      </div>

      {/* Bestsellers by Amount */}
      <div className="bg-white rounded-md shadow border overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between border-b px-4 py-2">
          <div className="flex items-center gap-2 text-gray-700 font-semibold">
            <Star size={18} />
            Bestsellers by amount
          </div>
          <button className="text-gray-400 text-xl font-bold hover:text-gray-600">
            –
          </button>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-left border-collapse">
            <thead>
              <tr className="bg-gray-100 text-gray-700">
                <th className="px-4 py-2 border">Name</th>
                <th className="px-4 py-2 border text-center">Total quantity</th>
                <th className="px-4 py-2 border">Total amount (excl tax)</th>
                <th className="px-4 py-2 border">View</th>
              </tr>
            </thead>
            <tbody>
              {bestsellersAmount.map((item, i) => (
                <tr key={i} className="border-t hover:bg-gray-50">
                  <td className="px-4 py-2 border">{item.name}</td>
                  <td className="px-4 py-2 border text-center">{item.qty}</td>
                  <td className="px-4 py-2 border">{item.amount}</td>
                  <td className="px-4 py-2 border text-center">
                    <button className="flex items-center gap-1 bg-gray-100 hover:bg-gray-200 text-gray-700 text-xs font-medium px-3 py-1 rounded">
                      <Eye size={14} /> View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer Pagination */}
        <div className="flex justify-between items-center border-t px-4 py-2 text-sm text-gray-600">
          <div className="flex items-center gap-1">
            <button className="border px-3 py-1 rounded-l bg-white hover:bg-gray-100">
              Previous
            </button>
            <button className="bg-blue-600 text-white px-3 py-1">1</button>
            <button className="border px-3 py-1 bg-white hover:bg-gray-100">
              2
            </button>
            <button className="border px-3 py-1 bg-white hover:bg-gray-100">
              3
            </button>
            <button className="border px-3 py-1 rounded-r bg-white hover:bg-gray-100">
              Next
            </button>
          </div>
          <span>1-5 of 12 items</span>
        </div>
      </div>
    </div>
  );
}
